import { authHeader } from '../../_helpers/auth-header';
import axios from 'axios';

export const dashBoardService = {
    dashBoardServiceApi,
    AssesserGroupList,
    invitePost,
    removeAssessment,
    sendRemainderIndividual,
    sendRemainderBulk,
    editAssessment,
    final_assessment_service,
    get_pdf
}

axios.defaults.headers.common = authHeader();

function dashBoardServiceApi(token) {
    return axios.get(`/assessments/user/active/assessments/?access_token=${token}`)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function AssesserGroupList(data) {
    return axios.get(`/users/organisation/assessor/group/list/edit/${data.sellerId}/${data.orgId}/`)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function invitePost(data) {
    return axios.post(`/assessments/user/respondent/allot/assessment/`,data)
    .then(handleResponse)
    .then(response => {
        return response
    })
}

function removeAssessment(data) {
    return axios.post(`/assessments/user/respondent/remove/assessment/`,data)
    .then(handleResponse)
    .then(response => {
        return response
    })
}

function editAssessment(data) {
    var token = localStorage.getItem('access_token')
    return axios.post(`/assessments/user/respondent/edit/assessment/relation/${data.assessment_id}/${data.respondent_id}/?access_token=${token}`,data.data)
    .then(handleResponse)
    .then(response => {
        return response
    })
}

function sendRemainderIndividual(data) {
    var token = localStorage.getItem('access_token')
    return axios.post(`/assessments/send/email/remainder/indivisual/?access_token=${token}`,data)
    .then(handleResponse)
    .then(response => {
        return response
    })
}

function sendRemainderBulk(data) {
    var token = localStorage.getItem('access_token')
    return axios.post(`/assessments/send/email/remainder/bulk/?access_token=${token}`,data)
    .then(handleResponse)
    .then(response => {
        return response
    })
}

function final_assessment_service(data) {
    var token = localStorage.getItem('access_token')
    return axios.post(`/assessments/submit/user/final/assessments/?access_token=${token}`, data)
        .then(handleResponse)
        .then(response => {
            return response
        })
}


function get_pdf(data, key) {
    var token = localStorage.getItem('access_token')

    let url;
    let payloadData = { ...data };  // Create a copy of the original data

    if (key === 'ROLE_FITMENT_LOI') {
        url = `assessments/report/role_fitment_loi/`;
    } else if (key === 'ROLE_FITMENT') {
        url = `analytics/organisation/role_fitment/new_content/${data.org_id}/`;
    } else if (key === 'vpiRawScore') {
        url = `assessments/vpi/raw/scores/?access_token=${token}`;
    } else if (key === 'vpiScore') {
        url = `assessments/goal-setting/worksheets/generate_pdf/?access_token=${token}`;
    } else if (key === 'plan') {
        url = `assessments/development/plan/pdf/data/?access_token=${token}`;
    } else if (key === 'selfDevPlan') {
        url = `assessments/development/self/plan/pdf/data/?access_token=${token}`;
    } else if (key === 'VVI') {
        url = `assessments/pdf/data/vvi/?access_token=${token}`;
    } else if (key === 'report' || key === 'self-report') {
        url = `/assessments/pdf/data/new/?access_token=${token}`; // New URL for both 'report' and 'self-report' keys
    } else if (key === 'self') {
        url = `/assessments/pdf/data/?access_token=${token}`;
    } else if (key === 'self_student') {
        url = `/assessments/pdf/data/single-rater/?access_token=${token}`;
        payloadData.is_student = true;  // Add is_student: true to the payload
    } else {
        url = `/assessments/pdf/data/single-rater/?access_token=${token}`;
    }

    return axios.post(url, payloadData)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(error => {
            throw error;
        });
}

function handleResponse(response) {
    if(response.status === 200) {
        if(response.organisation_list){
            if(response.organisation_list.length == 0){
                const error = 'No data to display';
                return Promise.reject(error);
            }
            return response;
        }
        return response;
    }
    else if(response.status === 201) {
        return response;
    } else if(response.status === 400) {
        const error404 = 'No data to display';
        return Promise.reject(error404);
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/_services/dashBoard/dashBoard.service.js